import React, { useState, useEffect, useContext } from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import ChatInput from "../Chat/ChatInput";
import { Images } from "../../assets/common";
import { SocketContext } from "../../context/socket";
import Picker from "emoji-picker-react";

import cookieStorage from "../../services/cookie-storage";
import Message from "../Chat/Message";
import {
  fullName,
  getErrorString,
  getUserDetail,
} from "../../constants/function";
import TipPopup from "../TipPopup";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useDispatch } from "react-redux";
import notifier from "../Notifier";
import ApiService from "../../services/api-service";
import Loader from "../Loader";
import OutsideClickHandler from "react-outside-click-handler";
import { useTranslation } from "react-i18next";
import { SkinTones } from 'emoji-picker-react';

export default function StreamingChat({
  playlistId,
  isOwner,
  closeFullscreen,
  leaveStreaming,
  streamData,
  artistId,
  isSubscribed,
}) {
  const { t } = useTranslation("common");
  const [typing, setTyping] = React.useState(false);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const userData = getUserDetail();

  const socket = useContext(SocketContext).Socket;
  const token = cookieStorage.getCookie("Authorization");
  const [openTip, setOpenTip] = useState(false);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const [newMessage, setNewMessage] = useState({});
  const [openEmoji, setOpenEmoji] = useState(false);
  const [hideChat, setHideChat] = useState(false);

  

  useEffect(() => {
    if (socket) socket.emit("join", { JWT: token, roomId: playlistId });
    getBlockedUserOfPlaylist(playlistId);
  }, []);

useEffect(() => {
  if (artistId && isSubscribed) {
    // Implement additional logic here if needed
  }
}, [artistId, isSubscribed]);
  


  const handleEnterPress = (event) => {
    if (event.keyCode === 13) {
      sendMessage();
    }
  };

  const onKeyup = (event) => {
    setMessage(event.target.value);
    if (event.keyCode === 13) {
      handleEnterPress(event);
    }
  };
  const sendMessage = () => {
    if (message.trim() !== "") {
      const msg = {
        roomId: playlistId,
        senderUserId: userData._id,
        message: message,
        _id: userData["_id"],
        JWT: token,
        isStreaming: true,
        user: {
          firstName: userData["firstName"],
          lastName: userData["lastName"],
          profileImg: userData["profileImg"],
          _id: userData["_id"],
          isVerified: userData["isVerified"],  // Include the isVerified field



        },
      };

      setMessage("");
      if (socket) socket.emit("chat_message", msg);

      msg["user"] = {
        firstName: userData["firstName"],
        lastName: userData["lastName"],
        profileImg: userData["profileImg"],
        _id: userData["_id"],
        isVerified: userData["isVerified"],  // Ensure this is set correctly

      };
      msg["_id"] = new Date().getTime();
      msg["createdAt"] = new Date();

      setNewMessage({ ...msg });
    }
  };
  const handleTip = async (amount, id, type, currency) => {
    if (amount) {
      setOpenTip(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: "livestream",
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_PLAYLIST(payload);

        setLoading(false);
        notifier.success(response["result"]);
        // setUserName(null);
        dispatch(getBalance());
        //NOTE handleed by backend
        // const msg = {
        //   isStreaming: true,
        //   roomId: playlistId,
        //   senderUserId: userData._id,
        //   amount: amount,
        //   message: `${fullName(
        //     userData
        //   )} has tipped ${amount} ${currency.toUpperCase()} `,
        //   _id: userData._id,
        //   JWT: token,
        //   type: "tip",
        // };

        // if (socket) socket.emit("chat_message", msg);
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };
  const onEmojiClick = (emojiObject, eventemojiObject) => {
    console.log("Selected Emoji Object:", emojiObject); // Check what emojiObject contains
    
    if (emojiObject && emojiObject.emoji) {
        setMessage((prevMessage) => prevMessage + emojiObject.emoji);
    } else {
    }
};
  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      setStatus(response?.result?.isBlocked ? "blocked" : "active");
    } catch (error) {}
  };

  useEffect(() => {
    if (socket) {
      socket.on("blocked", function (data) {
        if (data.userId === userData._id && playlistId === data.roomId) {
          setStatus(data["status"]);
          if (data["status"] === "blocked") {
            leaveStreaming();
          }
        }
      });
      // socket.on("notifyTyping", (msg) => {
      //   if (
      //     msg &&
      //     msg["senderUserId"] &&
      //     msg["senderUserId"] !== userData._id &&
      //     msg["roomId"] === playlistId
      //   ) {
      //     setTyping(msg["senderUserId"]);
      //     setTimeout(() => setTyping(false), 500);
      //   }
      // });
    }
  }, [socket]);


  

  return (
    <Box
      className="_streaming_chat"
      sx={{
        background: hideChat ? "none !important" : "initial",
        height: hideChat ? "50px !important" : "initial",
        minHeight: hideChat ? "50px !important" : "initial",
      }}
    >
      <Stack
        sx={{ height: "inherit" }}
        spacing={1}
        className={hideChat ? " _hide_messages" : ""}
      >
        {openEmoji ? (
          <OutsideClickHandler onOutsideClick={() => setOpenEmoji(false)}>
            <Picker
              pickerStyle={{ zIndex: "1" }}
              skinTone={SkinTones.MEDIUM_LIGHT}
              onEmojiClick={onEmojiClick}
              // native={true}
            />
          </OutsideClickHandler>
        ) : null}
        <Message
          isStream={true}
          roomId={playlistId}
          playListId={playlistId}
          type={"group"}
          senderUserId={userData._id}


          newMessage={newMessage}
          onChangeStatus={(status) => {
            setStatus(status);
          }}
        />
        
        <Box className="__chat_typing_streaming">
        </Box>
      </Stack>
      {status === "blocked" ? (
        <Stack
          direction="row"
          justifyContent="center"
          align="center"
          className="__chat_send"
        >
          <Typography
            sx={{
              color: "#5a5a5a",
              display: "flex",
              alignItems: "center",
              cursor: "default",
            }}
          >
            {"Blocked from owner"}
          </Typography>
        </Stack>
      ) : (
        <Stack
          className="_streaming_chat_input"
          alignitems="center"
          direction="row"
        >
          <input
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            onKeyUp={(e) => onKeyup(e)}
            type="text"
            placeholder="Type your message"
          />
          <Stack direction="row" alignitems="center" spacing={1}>
            <img
              aria-label="emoji"
              title="Open emoji"
              className="_cp"
              style={{ width: "26px" }}
              src={Images.emoji}
              alt="emoji"
              onClick={() => {
                setOpenEmoji(true);
              }}
            />
            {!isOwner ? (
              <img
                title="Tip playlist"
                className="_cp"
                onClick={() => {
                  setOpenTip(true);
                  // closeFullscreen();
                }}
                style={{ width: "24px" }}
                src={Images.tip_player}
                alt=""
              />
            ) : null}
            <IconButton onClick={() => setHideChat(!hideChat)}>
              <img
                className={hideChat ? "_arrow_up_chat" : "_arrow_down_chat"}
                style={{ width: "12px", height: "12px" }}
                src={Images.arrow_down}
                alt="arrow_down"
              />
            </IconButton>
            {/* {isOwner ? (
            <img
              className={"_cp "}
              style={{ width: "24px" }}
              src={Images.GIFT}
              alt=""
            />
          ) : null} */}
          </Stack>
        </Stack>
      )}
      {openTip ? (
        <TipPopup
          artist={streamData?.title}
          id={playlistId}
          open={openTip}
          isArtist={false}
          isPlaylist={true}
          handleClose={handleTip}
        />
      ) : null}
      {loading ? (
        <Loader
          wait={true}
          _class="__loader_inside"
          message={t("loader.message12")}
        />
      ) : null}
    </Box>
  );
}